import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=fc8cff7c"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports